import ContractCommodityActions from "@frameworks/web/redux/actions/Reports/ContractNotes/ContractCommodity";
import ContractStatementActions from "@frameworks/web/redux/actions/Reports/ContractNotes/ContractStatement";
export default () => {
    return {
        contract: new ContractStatementActions(),
        contractCommodityDetails: new ContractCommodityActions(),
    };
};
